import { IconButton, InputAdornment, Tooltip } from "@mui/material";
import { Check, Close } from "@mui/icons-material";

type PropsType = {
  isDirty: boolean;
  onSave: () => void;
  onDiscard: () => void;
  defaultAdornment?: React.ReactNode;
};

const EditableAdornment: React.FC<PropsType> = ({
  isDirty,
  onSave,
  onDiscard,
  defaultAdornment,
}) => {
  return (
    <InputAdornment position="end">
      {isDirty ? (
        <>
          <Tooltip title="Save">
            <IconButton
              size="small"
              color="success"
              onMouseDown={(e: React.MouseEvent) => {
                e.preventDefault();
                onSave();
              }}
            >
              <Check fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Discard">
            <IconButton
              size="small"
              color="error"
              onMouseDown={(e: React.MouseEvent) => {
                e.preventDefault();
                onDiscard();
              }}
            >
              <Close fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      ) : (
        defaultAdornment
      )}
    </InputAdornment>
  );
};

export default EditableAdornment;
